module.exports = __webpack_public_path__ + "static/media/studio-slide5.a1e98fd5.png";